import { FormControl, FormErrorMessage, Textarea } from "@chakra-ui/react";
import { Card } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { InvoiceTypeEnum, useInvoiceStore } from "../../../store";

export const InternalNoteCard = observer(function InternalNoteCard() {
  const store = useInvoiceStore();
  return (
    <Card sectioned>
      <h2 className="text-3xl font-semibold mb-8">
        <Trans>Internal note</Trans>
        <span style={{ fontWeight: "normal" }}>
          {store.type === InvoiceTypeEnum.CreditNote
            ? t`(Not visible on credit note)`
            : t`(Not visible on invoice)`}
        </span>
      </h2>
      <FormControl isInvalid={store.form.internal_note.hasError}>
        <Textarea
          onChange={(event) =>
            store.form.internal_note.onChange(event.target.value)
          }
          placeholder={t`Internal note`}
          rows={2}
          value={store.form.internal_note.value}
        />
        <FormErrorMessage>{store.form.internal_note.error}</FormErrorMessage>
      </FormControl>
    </Card>
  );
});
